import React, { useState } from "react";
import "./custom-checkbox.css";

const CustomCheckbox = ({isChecked, setIsChecked}) => {

  const toggleCheckbox = () => {
    setIsChecked(!isChecked);
  };

  return (
    <a className="custom-checkbox z-10" onClick={toggleCheckbox}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={toggleCheckbox}
        className="checkbox-input"
      />
      <span className="checkbox-box" >
        {isChecked && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
            className="checkbox-icon"
            onClick={toggleCheckbox}
          >
            <path onClick={toggleCheckbox} d="M20.285 6.707a1 1 0 0 0-1.57-1.414L9.5 14.586l-3.21-3.21a1 1 0 1 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l9-9z" />
          </svg>
        )}
      </span>
      <span className="checkbox-label text-[#87909E] font-mont font-[600]">Remember Me</span>
    </a>
  );
};

export default CustomCheckbox;
